import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  PinPointInput,
  SaveButton,
  FormRow,
  Radio,
} from '../../../components'

const FormContact = ({form, updateForm}) => {
  return (
    <form>
      <div className="flex items-center mb-5 lg:mb-8">
        <p className="text-lg font-bold">Headquarter</p>
        <div className="hidden lg:block mx-5">|</div>
        <div className="hidden lg:flex items-center">
          <p className="text-sm font-bold mr-4">Visibility:</p>
          <Radio
            name="visibilityHeadquarter"
            id="visibilityhq1"
            label="Public"
            value="public"
            className="mr-4"
            form={form}
            onChange={updateForm}
          />
          <Radio
            name="visibilityHeadquarter"
            id="visibilityhq2"
            label="Only me"
            value="onlyme"
            form={form}
            onChange={updateForm}
          />
        </div>
      </div>
      <FormRow>
        <Label>Email</Label>
        <Input className="w-full" defaultValue="salam@peacegen.id" type="email"/>
      </FormRow>
      <FormRow>
        <Label>Phone Number</Label>
        <Input className="w-full" defaultValue="+6222 7323101"/>
      </FormRow>
      <FormRow>
        <Label>Address</Label>
        <Input className="w-full" defaultValue="Jl. Cijagra No.48, Cijagra, Lengkong, Kota Bandung 40265"/>
      </FormRow>
      <FormRow last>
        <Label>Pin Point (Optional)</Label>
        <div className="-mx-5 sm:mx-0">
          <PinPointInput />
        </div>
      </FormRow>

      <SaveButton />
    </form>
  )
}

export { FormContact }
